/// <reference path='_all.ts' />


// CHEAT SHEET: http://ivision.com/wp-content/uploads/AngularJS_v2.pdf

/**
 * The main TodoMVC app module.
 *
 * @type {angular.Module}
 */
module product_references {
  'use strict';

  var product_references = angular.module('product-references', [])
    .controller('productReferenceCtrl', ProductReferenceCtrl)
    .filter('productReferenceFilter', ProductReferenceFilter)
    .service('productReferenceService', ProductReferenceService);
}